<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import toggleModal from '@/mixins/toggleModal';

const b = bem('new-frame-option');
export default {
  data() {
    return {
      option: {
        displayName: '',
        price: 1,
        inStock: true,
        isDefaultOption: false,
        isDefaultMinOption: false,
        additionalDiscount: 0,
        isPersonalize: false,
        frameColorId: null,
        frameSizeId: null,
        frameOrientation: 'vertical',
        isTaxApplied: true,
        personalizeImage: {
          imageKey: '',
          imageUri: '',
        },
        isMainOption: false,
        // isLicense: false,
      },
    };
  },
  props: {
    frameSizes: {
      type: Array,
      required: true,
    },
    frameColors: {
      type: Array,
      required: true,
    },
  },
  mixins: [toggleModal],
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      createFrameOptionAction: 'createTemplate/createFrameOption',
    }),
    handleOk(values) {
      const newOption = {
        option: values,
        frameId: this.frameDetails.id,
        type: this.frameDetails.name,
      };
      this.createFrameOptionAction(newOption);
      this.hideModal();
    },
  },
  computed: {
    ...mapState({
      frameDetails: (state) => state.createTemplate.frameDetails,
    }),
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" width="500px" @cancel="hideModal">
    <div :class="b('modal')">
      <FormKit
        type="form"
        submit-label="Create"
        @submit="handleOk"
      >
        <h1 class="text-2xl font-bold mb-2">New option</h1>
        <div :class="b('row')">
          <div :class="b('input')">
            <FormKit
              type="text"
              name="displayName"
              label="Display name"
              validation="required"
              placeholder="Display name"
              v-model:value="option.displayName"
            />
          </div>
          <div :class="b('input')">
            <FormKit
                type="select"
                name="frameOrientation"
                label="Orientation"
                placeholder="Please select orientation"
                v-model:value="option.frameOrientation"
                :options="[
                      { value: 'vertical', label: 'vertical'},
                      { value: 'horizontal', label: 'horizontal' }
                  ]"
                validation="required"
            />
          </div>
        </div>
        <div :class="b('row')">
          <div :class="b('input')">
            <FormKit
                type="number"
                name="price"
                label="Price"
                placeholder="Price"
                validation="required | integer"
                v-model:value="option.price"
            />
          </div>
          <div :class="b('input')">
            <FormKit
                type="number"
                name="additionalDiscount"
                label="Discount"
                placeholder="Discount"
                validation="required | integer"
                v-model:value="option.additionalDiscount"
            />
          </div>
        </div>
        <div :class="b('row')">
          <div :class="b('input')">
            <FormKit
                type="select"
                name="frameSizeId"
                label="Size"
                placeholder="Please select size"
                v-model:value="option.frameSizeId"
                :options="frameSizes"
                validation="required"
            />
          </div>
          <div :class="b('input')">
            <FormKit
                type="select"
                name="frameColorId"
                label="Color"
                placeholder="Please select color"
                v-model:value="option.frameColorId"
                :options="frameColors"
                validation="required"
            />
          </div>
        </div>
        <div :class="b('row')">
          <div :class="b('input')">
            <FormKit
                type="select"
                name="inStock"
                label="In stock"
                placeholder="Please select in stock"
                v-model:value="option.inStock"
                :options="[
                      { value: true, label: 'Yes'},
                      { value: false, label: 'No' }
                  ]"
                validation="required"
            />
          </div>
          <div :class="b('input')">
            <FormKit
                type="select"
                name="isDefaultOption"
                label="Is default"
                placeholder="Please select is default"
                v-model:value="option.isDefaultOption"
                :options="[
                      { value: true, label: 'Yes'},
                      { value: false, label: 'No' }
                  ]"
                validation="required"
            />
          </div>
        </div>
        <div :class="b('row')">
          <div :class="b('input')">
            <FormKit
                type="select"
                name="isDefaultMinOption"
                label="Is min default"
                placeholder="Please select is min default"
                v-model:value="option.isDefaultMinOption"
                :options="[
                      { value: true, label: 'Yes'},
                      { value: false, label: 'No' }
                  ]"
                validation="required"
            />
          </div>
          <div :class="b('input')">
            <FormKit
                type="select"
                name="isPersonalize"
                label="Is personalize"
                placeholder="Please select is personalize"
                v-model:value="option.isPersonalize"
                :options="[
                      { value: true, label: 'Yes'},
                      { value: false, label: 'No' }
                  ]"
                validation="required"
            />
          </div>
        </div>
<!--        <div :class="b('input')">-->
<!--          <FormKit-->
<!--              type="select"-->
<!--              name="isLicense"-->
<!--              label="License"-->
<!--              placeholder="Is License"-->
<!--              v-model:value="option.isLicense"-->
<!--              :options="[-->
<!--                      { value: true, label: 'Yes'},-->
<!--                      { value: false, label: 'no' }-->
<!--                  ]"-->
<!--              validation="required"-->
<!--          />-->
<!--        </div>-->
      </FormKit>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
@import "@/styles/variables";

.new-frame-option {
  &__row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  &__column {
    margin-bottom: 20px;
  }

  &__input {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &__button {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
}
.formkit-outer {
  width: 100%;
}
</style>
